module.exports = __webpack_public_path__ + "img/hyper.50bf2659.jpg";